const  view = /*html*/ `
    <!--begin::Container-->
    <div class="separator mb-4 mx-9"></div>
    <div class="container-fluid d-flex flex-column flex-md-row align-items-start justify-content-between">
        <div class="d-flex gap-4">
            <a href="https://pdxplay.org">
                <img class="img-fluid w-90px" src="assets/media/logos/pdxplay_render.png" class="" alt="ParadoxTeam">
            </a>
            <div class="text-dark d-flex flex-column order-2 order-md-1 justify-content-center">
                <span class="text-muted fw-bolder me-1">© 2017 - ${new Date().getFullYear()}</span>
                <span class="fs-8 text-gray-600" data-i18n="[html]footer.slogan">The definitive platform for</br>competitive Counter-Strike 1.6</span>
            </div>
        </div>
        
        <div class="d-flex flex-column text-dark order-2 order-md-1">
            <div class="d-flex gap-2">
                <div class="d-flex align-items-center">
                <a href="https://twitter.com/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                    <i class="fab fa-twitter fs-4"></i>
                </a>
                </div>
                <div class="d-flex align-items-center">
                    <a href="https://www.instagram.com/pdxplay/" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-instagram fs-4"></i>
                    </a>
                </div>
                
                <div class="d-flex align-items-center">
                    <a href="https://www.twitch.tv/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-twitch fs-4"></i>
                    </a>
                </div>

                <div class="d-flex align-items-center">
                    <a href="https://www.youtube.com/@pDxPLAY" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-youtube fs-4"></i>
                    </a>
                </div>

                <div class="d-flex align-items-center">
                    <a href="https://steamcommunity.com/groups/pdxplaycs16" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-steam fs-4"></i>
                    </a>
                </div>
                <div class="d-flex align-items-center">
                    <a href="https://discord.gg/9u4mHsf3dD" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-discord fs-4"></i>
                    </a>
                </div>
                <div class="d-flex align-items-center">
                    <a href="https://whatsapp.com/channel/0029VaDpiuXKwqSQwvWh2v24" target="_blank" class="btn btn-icon btn-color-gray-600 btn-active-color-white">
                        <i class="fab fa-whatsapp fs-4"></i>
                    </a>
                </div>

                <div class="d-flex align-items-center">
                    <a href="ts3server://ts.pdxplay.org" class="btn btn-icon btn-color-gray-600 btn-active-color-white external-handler">
                        <i class="fab fa-teamspeak fs-4"></i>
                    </a>
                </div>
            </div>
        </div>
    </div>
    <!--end::Container-->
`;

export default view;